/**
 * Página de Términos y Condiciones
 * 
 * Esta página muestra la política de devoluciones y reembolsos
 * y los términos y condiciones de Liga ProKids.
 */

const Terms = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '50px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="container"
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '15px',
              color: '#061156',
              lineHeight: '1.2',
            }}
          >
            📋 Términos y Condiciones
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              marginBottom: '0',
              color: '#061156',
              lineHeight: '1.6',
              maxWidth: '800px',
            }}
          >
            Condiciones específicas de devolución y reembolso de Liga ProKids.
          </p>
        </div>
      </section>

      {/* Contenido de Términos y Condiciones */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '900px',
              margin: '0 auto',
              lineHeight: '1.8',
            }}
          >
            {/* Política de devoluciones y reembolsos */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                Política de devoluciones y reembolsos
              </h2>

              <p
                style={{
                  fontSize: '1.2rem',
                  color: '#333',
                  marginBottom: '30px',
                  textAlign: 'justify',
                }}
              >
                En Liga ProKids trabajamos para ofrecer la mejor experiencia posible a todos nuestros
                participantes y familias. A continuación, detallamos nuestras condiciones específicas de
                devolución y reembolso:
              </p>

              {/* Condiciones específicas */}
              <div
                style={{
                  backgroundColor: '#F8F9FA',
                  border: '1px solid #E9ECEF',
                  borderRadius: '10px',
                  padding: '30px',
                  marginBottom: '30px',
                }}
              >
                <h3
                  style={{
                    fontSize: '1.4rem',
                    fontWeight: '600',
                    marginBottom: '20px',
                    color: '#061156',
                  }}
                >
                  Reembolsos de Jornadas
                </h3>
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                  <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                    <strong>Plazo para posponer la asistencia:</strong>
                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                      <li style={{ marginBottom: '8px', fontSize: '1rem' }}>
                        Cuando la jornada se disputa en domingo, el participante podrá cancelar su
                        asistencia hasta el jueves a las 23:59 a través del botón &quot;No voy&quot; en la App.
                      </li>
                      <li style={{ marginBottom: '0', fontSize: '1rem' }}>
                        Cuando la jornada se disputa en sábado, el plazo límite será el miércoles a las
                        23:59.
                      </li>
                    </ul>
                  </li>
                  <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                    <strong>Reembolso automático:</strong> Si la cancelación se realiza dentro del plazo,
                    el reembolso se efectúa automáticamente en el método de pago original.
                  </li>
                  <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                    <strong>Cancelaciones fuera de plazo:</strong> Si el usuario no realiza la posposición
                    dentro del plazo, no se aplicará ningún reembolso.
                  </li>
                  <li style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                    <strong>Suspensión por parte de la organización:</strong>
                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                      <li style={{ marginBottom: '8px', fontSize: '1rem' }}>
                        En caso de que Liga ProKids decida suspender una jornada por condiciones
                        meteorológicas u otras causas de fuerza mayor, se devolverá el importe
                        correspondiente, incluso si el plazo de posposición para los usuarios ya hubiera
                        finalizado.
                      </li>
                      <li style={{ marginBottom: '0', fontSize: '1rem' }}>
                        Si la jornada se celebra con normalidad y el usuario no ha gestionado su
                        posposición dentro del plazo, no se generará devolución.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

            {/* Nueva sección de Productos y Merchandising */}
            <div
              style={{
                backgroundColor: '#F8F9FA',
                border: '1px solid #E9ECEF',
                borderRadius: '10px',
                padding: '30px',
                marginBottom: '30px',
              }}
            >
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                Productos y Merchandising
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                En caso de adquirir artículos oficiales de Liga ProKids (merchandising):
              </p>
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  Para ser elegible para devolución, el producto debe estar sin usar y en la misma
                  condición en que fue recibido, incluyendo el embalaje original.
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <strong>Artículos no retornables:</strong> tarjetas de regalo
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <strong>Reembolsos parciales:</strong> se podrán aplicar en casos de artículos con signos de uso
                  evidente, piezas faltantes o daños no atribuibles a la organización.
                </li>
                <li style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                  El comprador será responsable de los costes de envío en devoluciones de productos.
                </li>
              </ul>
            </div>
            </div>

            {/* Proceso de reembolsos */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                Proceso de Reembolsos
              </h2>

              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  Una vez procesada la cancelación o recibida la devolución del producto, se notificará
                  por correo electrónico si el reembolso ha sido aprobado.
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  Los reembolsos se procesan automáticamente al mismo método de pago utilizado en la
                  compra.
                </li>
                <li style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                  Si el reembolso tarda más de lo esperado, el usuario deberá contactar con su entidad
                  bancaria o con la organización en <strong>contacto@ligaprokids.es</strong>.
                </li>
              </ul>
            </div>

            {/* Sección de Intercambios */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                Intercambios
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                Solo se reemplazarán artículos si están defectuosos o dañados. Para solicitar un intercambio,
                escríbenos a <strong>contacto@ligaprokids.es</strong>.
              </p>
            </div>

            {/* Información de contacto */}
            <div
              style={{
                backgroundColor: '#F8F9FA',
                border: '1px solid #E9ECEF',
                borderRadius: '10px',
                padding: '30px',
                marginBottom: '40px',
                textAlign: 'center',
              }}
            >
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  color: '#061156',
                }}
              >
                ¿Necesita ayuda?
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  margin: 0,
                }}
              >
                Para dudas sobre reembolsos y devoluciones, comuníquese con nosotros a{' '}
                <strong>contacto@ligaprokids.es</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Contacto */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          textAlign: 'center',
        }}
      >
        <div className="container" style={containerStyle}>
          <h2
            style={{
              fontSize: '2rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#061156',
            }}
          >
            ¿Tienes alguna consulta sobre nuestros términos?
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '30px',
            }}
          >
            Si tienes alguna pregunta sobre nuestros términos y condiciones,
            no dudes en contactarnos.
          </p>
          <a
            href="/contact"
            style={{
              display: 'inline-block',
              padding: '15px 40px',
              backgroundColor: '#4352A9',
              color: 'white',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1.1rem',
              textDecoration: 'none',
              border: '2px solid #4352A9',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(67, 82, 169, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#4352A9';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#4352A9';
              e.target.style.color = 'white';
            }}
          >
            Contactar
          </a>
        </div>
      </section>
    </>
  );
};

export default Terms;
